import { DefinitionsActionTypes  } from './definitions.types';
import axios from 'axios';


export const setFormChatStatus = (payload) => {
  return dispatch => {
    dispatch({ type:DefinitionsActionTypes.SET_CHATFORM_STATUS, formChatOpenStatus: payload})
  }
}